import { signOut } from 'firebase/auth';
import { NavLink, Outlet } from 'react-router';
import { useAdmin } from '../auth/AuthProvider';
import { auth } from '../lib/firebase';

export const SECTIONS = [
  { path: '/products', label: 'المنتجات' },
  { path: '/categories', label: 'التصنيفات والمجموعات' },
  { path: '/home', label: 'الصفحة الرئيسية' },
  { path: '/content', label: 'المحتوى' },
  { path: '/orders', label: 'الطلبات' },
  { path: '/customers', label: 'الزبائن' },
  { path: '/leads', label: 'طلبات الشركات' },
  { path: '/redirects', label: 'التحويلات' },
  { path: '/settings', label: 'الإعدادات' },
  { path: '/audit', label: 'سجل التعديلات' },
] as const;

export function AppLayout() {
  const user = useAdmin();

  return (
    <div className="flex min-h-dvh">
      <aside className="w-60 shrink-0 border-e border-sand bg-white">
        <div className="border-b border-sand px-5 py-4">
          <NavLink to="/" aria-label="دار · الرئيسية" className="block">
            <img src="/dar-lockup-light.svg" alt="" width={108} height={30} className="h-[30px] w-auto" />
          </NavLink>
        </div>
        <nav className="flex flex-col py-2">
          {SECTIONS.map((s) => (
            <NavLink
              key={s.path}
              to={s.path}
              className={({ isActive }) =>
                `border-s-2 px-5 py-2.5 ${isActive ? 'border-espresso bg-cream font-bold' : 'border-transparent hover:bg-cream'}`
              }
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-end gap-4 border-b border-sand bg-white px-6 py-3 text-sm">
          <span dir="ltr" className="text-muted">
            {user.email}
          </span>
          <button type="button" onClick={() => signOut(auth)} className="underline underline-offset-4 hover:text-clay">
            تسجيل الخروج
          </button>
        </header>
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
